/** @jsx h */
import 'core-js-pure/features/promise'; // To support browsers that do not yet implement Promise.any() and AggregateError
import { Provider } from 'preact-redux';
import { h } from 'preact';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
// import * as Sentry from '@sentry/browser';
import { Bugfender } from '@bugfender/sdk';
// eslint-disable-next-line no-unused-vars
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import SupportedBrowserProvider from './components/global/supported-browser';
import configureStore from './store/configure-store';
import {
  appVersion, /* ENVIRONMENTS , */
} from './utils/consts';
import './style/index.scss';

import FireBase from './services/FireBase';

FireBase.initialise();

const { detect } = require('detect-browser');

const browser = detect();

const supportedBrowsers = ['chrome', 'safari', 'ios', 'ios-webview'];
const supportedOperatingSystem = ['Android OS', 'iOS'];

const supported = supportedBrowsers.indexOf(browser.name) >= 0;
const supportedOS = supportedOperatingSystem.indexOf(browser.os) >= 0;

if ((supported || supportedOS) /* && process.env.PREACT_APP_ENV === ENVIRONMENTS.PRODUCTION */) {
  // Sentry.init({
  //   dsn: process.env.PREACT_APP_SENTRY_DSN,
  //   environment: process.env.PREACT_APP_ENV,
  //   release: `telmie2@${appVersion}`,
  // });
  Bugfender.init({
    appKey: process.env.PREACT_APP_BUGFENDER_API_KEY,
    overrideConsoleMethods: false,
    version: `telmie2@${appVersion}`,
    logBrowserEvents: false,
    logUIEvents: false,
    printToConsole: false,
  });
}

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#5d5cf6',
    pickerHeaderColor: '#5d5cf6',
  },
  datePicker: {
    selectColor: '#5d5cf6',
    // calendarYearBackgroundColor: '#5d5cf6',
    headerColor: '#5d5cf6',
  },
});

const Index = () => {
  UIkit.use(Icons);
  // eslint-disable-next-line global-require
  const App = require('./components/app').default;

  const result = (
    <Provider store={configureStore({})}>
      <MuiThemeProvider muiTheme={muiTheme}>
        <SupportedBrowserProvider isSupportedBrowser={supported} isSupportedOS={supportedOS}>
          <App />
        </SupportedBrowserProvider>
      </MuiThemeProvider>
    </Provider>
  );
  return result;
};

export default () => Index();



// WEBPACK FOOTER //
// ./index.js